import produce from "immer"
import { InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

const initHelpState: types.HelpState = {
    helpList: {},
}

const helpReducer = produce((
    draft: types.HelpState = initHelpState,
    action: ActionTypes = null,
): types.HelpState => {
    switch (action.type) {
        case types.HELP_LIST:
            draft.helpList = action.helpList
            return draft

        default:
            return draft
    }
})
export default helpReducer
